<template>
    <div class="root_page_center wrapper_setting wrapper_setting_bgr">
        <div class="frm_setting">
            <form action="" method="post" id="frm_st" @submit="sendBusiness($event)">
                <div class="bgr_fff_mobile">
                    <h2 class="titleFrm_setting">Thông tin doanh nghiệp</h2>
                    <div class="input_setting">
                        <label>Tên công ty</label>
                        <!-- <input type="text" v-model="company_name" placeholder="Tên công ty"> -->
                        <textarea v-model="company_name" @input="company_name = company_name.toUpperCase()" rows="2" placeholder="Tên công ty"></textarea>
                    </div>
                    <div class="input_setting">
                        <label>Mã số thuế</label>
                        <input type="text" v-model="taxCode" placeholder="Mã số thuế">
                    </div>
                    <div class="input_setting">
                        <label>Người đại diện</label>
                        <input type="text" v-model="staff" @input="staff = staff.toUpperCase()" placeholder="Người đại diện">
                    </div>
                    <div class="input_setting">
                        <label>Địa chỉ trụ sở</label>
                        <!-- <input type="text" v-model="address" placeholder="Địa chỉ trụ sở"> -->
                        <textarea v-model="address" @input="capitalizeWords('address')" rows="2" placeholder="Địa chỉ trụ sở"></textarea>
                    </div>
                    <div class="input_setting">
                        <label>Số điện thoại</label>
                        <input type="tel" inputmode="numeric" pattern="[0-9]*" maxlength="11" @input="phone = phone.replace(/[^0-9]/g, '')" v-model="phone" placeholder="Số điện thoại">
                    </div>
                    <div class="input_setting">
                        <label>Vốn điều lệ</label>
                        <input type="text" inputmode="numeric" v-model="showMoney" @input="onNumberInput" ref="input_amount" placeholder="Vốn điều lệ">
                    </div>
                    <div class="input_setting">
                        <label>Ngày thành lập</label>
                        <Datepicker v-model="date" select-text="Chọn" cancel-text="Hủy" :format-locale="vi" :format="format" :enable-time-picker="false" placeholder="Ngày thành lập"/>
                    </div>
                    <div class="input_setting">
                        <label>Ngành nghề chính</label>
                        <input type="text" v-model="job" placeholder="Ngành nghề chính">
                    </div>
                    <div class="input_setting input_settingVselect">
                        <label>Tên ngân hàng</label>
                        <v-select
                            v-model="bankname"
                            :options="listBank"
                            label="name"
                            :reduce="bank => bank.id"
                            placeholder="Chọn ngân hàng"
                        >
                            <template #option="{ name, image }">
                                <img :src="linkWebAdmin + image" style="height: 20px; margin-right: 8px;width: 60px;object-fit: contain;" />
                                {{ name }}
                            </template>
                            <template #selected-option="{ name, image }">
                                <img :src="linkWebAdmin + image" style="height: 20px; margin-right: 8px;width: 60px;object-fit: contain;" />
                                {{ name }}
                            </template>
                        </v-select>
                    </div>
                    <div class="input_setting">
                        <label>Số tài khoản</label>
                        <!--  @blur="handleBlurBank()" -->
                        <input type="text" @input="banknumber = banknumber.replace(/\D/g, '')" inputmode="numeric" pattern="[0-9]*" v-model="banknumber" placeholder="Số tài khoản">
                    </div>
                    <div class="input_setting">
                        <label>Loại hình doanh nghiệp</label>
                        <select v-model="companyType">
                            <option value="" selected="selected">Loại hình doanh nghiệp</option>
                            <option :value="item.id" v-for="(item, index) in listCompany" :key="index">{{  item.name }}</option>
                        </select>
                    </div>
                    <div class="input_setting">
                        <label>Cán bộ quản lý</label>
                        <input type="text" v-model="management" @input="capitalizeWords('management')" placeholder="Cán bộ quản lý">
                    </div>
                    <div class="input_setting">
                        <label>Email</label>
                        <input type="email" v-model="email" placeholder="Email">
                    </div>
                </div>
                <div class="bgr_fff_mobile">
                    <h3 class="titleFrm_setting titleFrm_settings">Thông tin chủ doanh nghiệp</h3>
                    <div class="input_setting">
                        <label>Họ và tên</label>
                        <input type="text" v-model="fullname" @input="fullname = fullname.toUpperCase()" placeholder="Họ và tên">
                    </div>
                    <div class="input_setting">
                        <label>Ngày tháng năm sinh</label>
                        <Datepicker v-model="birthday" select-text="Chọn" cancel-text="Hủy" :format-locale="vi" :format="format" :enable-time-picker="false" placeholder="Ngày, tháng, năm sinh"/>
                    </div>
                    <div class="input_setting">
                        <label>Số CMND / CCCD</label>
                        <input type="text" @input="banknumber = banknumber.replace(/\D/g, '')" inputmode="numeric" pattern="[0-9]*" v-model="identity_number" placeholder="Số CMND / CCCD">
                    </div>
                    <div class="input_setting">
                        <label>Giới tính</label>
                        <select v-model="sex">
                            <option value="" selected>Giới tính</option>
                            <option value="Nam">Nam</option>
                            <option value="Nữ">Nữ</option>
                        </select>
                    </div>
                    <div class="input_setting">
                        <label>Quốc tịch</label>
                        <input type="text" v-model="nationality" placeholder="Quốc tịch">
                    </div>
                    <div class="input_setting">
                        <label>Nơi thường trú</label>
                        <input type="text" v-model="residence" placeholder="Nơi thường trú">
                    </div>
                    <div class="input_setting">
                        <label>Ngày cấp</label>
                        <Datepicker v-model="dateIssue" select-text="Chọn" cancel-text="Hủy" :format-locale="vi" :format="format" :enable-time-picker="false" placeholder="Ngày cấp"/>
                    </div>
                    <div class="input_setting">
                        <label>Nơi cấp</label>
                        <!-- <input type="text" v-model="placeIssue" placeholder="Nơi cấp"> -->
                        <textarea v-model="placeIssue" rows="2" placeholder="Nơi cấp"></textarea>
                    </div>
                </div>
                <div class="btn_setting">
                    <button type="submit">Cập nhật hồ sơ</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
import viCustom from '@/locales/vi-custom'
import SocketIO from 'socket.io-client'
export default {
    name: 'Setting_tool',
    data () {
        return {
            vi: viCustom,
            token: window.localStorage.getItem('token'),
            company_name: '',
            taxCode: '',
            staff: '',
            address: '',
            phone: '',
            money: '',
            showMoney: '',
            date: '',
            job: '',
            management: '',
            email: '',
            bankname: null,
            banknumber: '',
            companyType: '',
            fullname: '',
            birthday: '',
            identity_number: '',
            sex: '',
            nationality: 'Việt Nam',
            residence: '',
            dateIssue: '',
            placeIssue: '',

            listCompany: [],
            format: 'dd/MM/yyyy',
            listBank: [],
            socket: null,
            orther: []
        }
    },
    components: {
        Datepicker,
        vSelect
    },
    mounted () {
        
    },
    created () {
        this.getCompany()
        this.getDataListInfo()
        this.getDataListInfoSetting()
        this.getListBank()
        this.socketEventSetting()
    },
    computed: {
        
    },
    beforeUnmount () {
        if (this.socket) {
            this.socket.disconnect()
        }
    },
    methods: {
        getListBank () {
            this.axios.get(this.api_logoBanks).then((response) => {
                this.listBank = response.data.data
            })
        },
        getCompany () {
            this.axios.get(this.api_getCompany).then((response) => {
                this.listCompany = response.data.data
            })
        },
        getDataListInfo () {
            this.axios.get(this.api_userInfo,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.fullname = response.data.data.name
                this.phone = response.data.data.phone
                // this.bankname = Number(response.data.data.bank_id)
                this.bankname = response.data.data.bank_id == 0 ? null : Number(response.data.data.bank_id);
                this.companyType = Number(response.data.data.company_type)
                this.taxCode = response.data.data.tax_code
                this.birthday = new Date(response.data.data.dob)
                this.identity_number = response.data.data.identity_number
                this.sex = response.data.data.gender
                // this.nationality = response.data.data.nationality
                this.residence = response.data.data.permanent_address
                this.email = response.data.data.email
                if(response.data.data.issue_date == null){
                    this.dateIssue = ''
                }else{
                    this.dateIssue = new Date(response.data.data.issue_date)
                }
                this.placeIssue = response.data.data.issue_place
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        getDataListInfoSetting () {
            this.axios.get(this.api_getBusiness,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                if(response.data.data != null){
                    this.company_name = response.data.data.company_name
                    this.staff = response.data.data.representative_name
                    this.address = response.data.data.head_office_address
                    this.phone = response.data.data.phone_number
                    this.money = response.data.data.charter_capital
                    this.showMoney = this.formatNumber(String(this.money))
                    if(response.data.data.establishment_date == null){
                        this.date = ''
                    }else{
                        this.date = new Date(response.data.data.establishment_date)
                    }
                    this.job = response.data.data.main_business_line
                    this.management = response.data.data.staff_name
                    this.banknumber = response.data.data.bank_account_number
                }
            })
        },
        sendBusiness (e){
            e.preventDefault()
            $('#loadingImg').show().fadeIn(10)
            this.axios.post(this.api_postBusiness, 
                {
                    company_name: this.company_name,
                    tax_code: this.taxCode,
                    representative_name: this.staff,
                    head_office_address: this.address,
                    phone_number: this.phone,
                    charter_capital: this.money,
                    establishment_date: this.formatDate(this.date),
                    main_business_line: this.job,
                    staff_name: this.management,
                    email: this.email,
                    bank_name: this.bankname,
                    bank_account_number: this.banknumber,
                    business_type: this.companyType,
                    name: this.fullname,
                    dob: this.formatDate(this.birthday),
                    identity_number: this.identity_number,
                    gender: this.sex,
                    nationality: this.nationality,
                    permanent_address: this.residence,
                    issue_date: this.formatDate(this.dateIssue),
                    issue_place: this.placeIssue,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                $('#loadingImg').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
            }).catch(e => {
                $('#loadingImg').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: e.response.data.errors,
                    showConfirmButton: false,
                    timer: 2000
                })
            })
        },
        formatDate(date) {
            if (!date) return ''
            const yyyy = date.getFullYear()
            const dd = String(date.getDate()).padStart(2, '0')
            const mm = String(date.getMonth() + 1).padStart(2, '0')
            return `${yyyy}-${mm}-${dd}`
        },
        formatNumber(value) {
            const cleaned = value.split('.')[0];
            const num = cleaned.replace(/\D/g, '');
            return num.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
        onNumberInput(e) {
            // const raw = e.target.value.replace(/,/g, '');
            const raw = e.target.value.replace(/\./g, '');
            this.money = raw
            this.showMoney = this.formatNumber(raw);
        },
        socketEventSetting () {
            let thiss = this
            var idUser = window.localStorage.getItem('idUser')
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_load-business.${idUser}:ReloadEvent`, function(result) {
                // console.log('2222', result.data);
                if(result.data.load_business == true){
                    thiss.getDataListInfo()
                    thiss.getDataListInfoSetting()
                }
            });
        },
        handleBlurBank() {
            this.axios.post(this.api_updateBankNumber, 
                {
                    bank_name: this.bankname,
                    bank_account_number: this.banknumber,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.orther = response
            })
        },
        capitalizeWords(fieldName) {
            if (!this[fieldName]) return;
            this[fieldName] = this[fieldName].split(' ').map(word => {
                if (!word) return '';
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }).join(' ');
        },
    }
}
</script>